import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CodeResponse } from './codes.model';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CodesService {
  
  constructor(private http: HttpClient) {
  }

  get(code: string): Observable<CodeResponse> {
    return this.http.get<CodeResponse>(`${environment.apiHost}/codes/${code}`);
  }
}
